import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import axiApi from "ApiCaller";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import {publishEvent} from "core/eventsConnector";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

/**
 * Botón para borrar una ruta instanciada que la app de cabina no ha iniciado nunca.
 * Solo se pinta si la ruta trae can_delete (lo calcula el backend). Tras borrar publica "route:deleted" con
 * {id, type} y vuelve al calendario, salvo que se pase onDeleted (p. ej. cerrar un modal).
 */
const ButtonDeleteRoute = ({route, onDeleted = null, className = "btn btn-outline-danger btn-sm me-3"}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _CT} = useCustomTranslation(translations);
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    });

    if (!route?.id || !route.can_delete) return null;

    const onClick = () => {
        AlertQuestion.warning(_CT("delete-question-title"), _CT("delete-question-text")).then((r) => {
            if (!r.isConfirmed) return;
            axiApi
                .delete("/api/distribution/route/", {data: {id: route.id}})
                .then((resp) => {
                    if (!resp.data.status) {
                        Alert.error(_CT("delete-error"));
                        return;
                    }
                    Alert.success(_CT("delete-ok-title"), _CT("delete-ok-text"));
                    publishEvent("route:deleted", {id: route.id, type: route.type});
                    if (onDeleted) {
                        onDeleted(route);
                    } else {
                        navigate("/route-management/calendar/");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    Alert.error(_CT("delete-error"));
                });
        });
    };

    return (
        <button type="button" className={className} onClick={onClick}>
            <FontAwesomeIcon icon="trash" /> {_CT("delete")}
        </button>
    );
};

export default ButtonDeleteRoute;
